'use client';

import NumberFormatter from '@/utils/bn';
import { CurrencyInfo } from '@hidayahlab/academy-suite-corelib';
import { cn } from '@tajdid/tajdid-ui';
import { useLocale } from 'next-intl';

type CourseCardPriceProps = {
  price: number;
  discount?: number;
  discountPrice?: number;
  isFree?: boolean;
  className?: string;
  currencyInfo: CurrencyInfo;
};
export default function CoursePricing({
  price,
  discountPrice,
  isFree,
  className,
  currencyInfo,
}: CourseCardPriceProps) {
  const local = useLocale();

  return (
    <div className={cn(className, 'flex gap-3 items-center')}>
      <p className="text-2xl font-bold text-primary-500">
        {isFree || price === 0
          ? local === 'bn'
            ? 'ফ্রী'
            : 'Free'
          : `${local === 'bn' ? `${currencyInfo.symbol}${NumberFormatter(discountPrice ?? 0)} ` : `${currencyInfo.symbol}${discountPrice}`}`}
      </p>

      {!isFree && price !== discountPrice && (
        <p className="font-semibold line-through lg:mt-2 text-body">
          {local === 'bn'
            ? `${currencyInfo.symbol} ${NumberFormatter(price)}`
            : `${currencyInfo.symbol}${price}`}
        </p>
      )}
    </div>
  );
}
